import { PhotoControl } from '@components/PhotoControl/PhotoControl'
import {
  Anchor,
  Box,
  Button,
  Checkbox,
  Flex,
  MultiSelect,
  Select,
  Stack,
  Text,
  TextInput,
  Textarea,
  Title,
} from '@mantine/core'
import classes from './LocationPublicProfile.module.css'
import { useState } from 'react'

export const LocationPublicProfile = () => {
  const [services, setServices] = useState<string[]>([])
  const [addressIsOrganization, setAddressIsOrganization] =
    useState<boolean>(true)
  const [urlIsOrganization, setUrlIsOrganization] = useState<boolean>(true)

  const handleAddMore = () => {
    setServices([...services, ''])
  }

  return (
    <>
      <Flex p="md" gap={60} wrap="wrap">
        <Box>
          <Title order={4}>Profile</Title>
          <Stack mt="lg">
            <TextInput
              maw={450}
              size="md"
              label="Location name"
              defaultValue="PS 100 Alfred Nobel School"
              withAsterisk
            />
            <TextInput maw={450} size="md" label="Middle name" />
            <TextInput
              maw={450}
              size="md"
              label="Short name"
              defaultValue="PS 100"
              withAsterisk
            />
            <Textarea
              maw={450}
              size="md"
              label="About"
              rows={4}
              value="A K-12 public school serving the Park Slope community in Brooklyn."
              withAsterisk
            />
            <MultiSelect
              size="md"
              maw={450}
              description="List the languages that staff can assist customers in."
              label="Languages"
              data={[
                {
                  label: 'English',
                  value: 'English',
                },
                {
                  label: 'Italian',
                  value: 'Italian',
                },
                {
                  label: 'Mandarin',
                  value: 'Mandarin',
                },
              ]}
              placeholder="Select one or more"
            />
            <TextInput
              maw={450}
              size="md"
              label="Services"
              description="Used for search and to allow staff who opt-in to identify themselves as a point of contact for any service listed below."
              withAsterisk
            />
            <Stack>
              {services.map((_, i) => (
                <TextInput key={`services-${i}`} maw={450} size="md" />
              ))}
              <Anchor onClick={handleAddMore}>+ Add more</Anchor>
            </Stack>
          </Stack>
        </Box>
        <Box style={{ flex: '1 1 auto' }}>
          <Title order={4}>Profile Picture</Title>
          <Box mt="lg">
            <PhotoControl />
          </Box>
          <Stack mt="lg">
            <Title order={4}>Contact Info</Title>
            <Stack gap="xs">
              <Text>
                Customer support email{' '}
                <Text c="red" span>
                  *
                </Text>
              </Text>
              <Flex align="center" gap="xs" maw={450}>
                <TextInput
                  size="md"
                  defaultValue="alfredo@mybluecard.org"
                  placeholder="name@example.com"
                  style={{ flexGrow: 1, flexShrink: 1 }}
                />
                <Box className={classes.LocationPublicProfile__label} p="xs">
                  <Text tt="uppercase" c="dimmed" fw="bold" size="sm">
                    Support
                  </Text>
                </Box>
              </Flex>
              <Text mt="xs">
                Customer support phone number{' '}
                <Text c="red" span>
                  *
                </Text>
              </Text>
              <Flex align="center" gap="xs" maw={450}>
                <TextInput
                  size="md"
                  value="+1 (212) 555-1212"
                  placeholder="+1 (212) 555-1212"
                  style={{ flexGrow: 1, flexShrink: 1 }}
                />
                <Box className={classes.LocationPublicProfile__label} p="xs">
                  <Text tt="uppercase" c="dimmed" fw="bold" size="sm">
                    SUPPORT
                  </Text>
                </Box>
              </Flex>
            </Stack>
          </Stack>
          <Stack gap="xs" mt="lg">
            <Text size="md">
              Address{' '}
              <Text c="red" span>
                *
              </Text>
            </Text>
            <Checkbox
              label={
                <Text size="sm" c="dark">
                  Same as organization
                </Text>
              }
              onClick={() => setAddressIsOrganization(!addressIsOrganization)}
              checked={addressIsOrganization}
            />
            <Select
              maw={450}
              size="md"
              data={[
                {
                  label: 'United States',
                  value: 'UNITED_STATES',
                },
              ]}
              value="UNITED_STATES"
              disabled={addressIsOrganization}
            />
            <TextInput
              maw={450}
              size="md"
              placeholder="Address line 1"
              defaultValue="505 Park Avenue"
              disabled={addressIsOrganization}
            />
            <TextInput
              maw={450}
              size="md"
              placeholder="Address line 2"
              defaultValue="Suite 1000"
              disabled={addressIsOrganization}
            />
            <TextInput
              maw={450}
              size="md"
              placeholder="City"
              defaultValue="New York"
              disabled={addressIsOrganization}
            />
            <Flex maw={450} gap="xs">
              <Select
                size="md"
                data={['Florida', 'New York']}
                placeholder="State"
                value="New York"
                disabled={addressIsOrganization}
              />
              <TextInput
                size="md"
                placeholder="Zipcode"
                defaultValue="10010"
                disabled={addressIsOrganization}
              />
            </Flex>
            <Title order={4} mt="md">
              URLs
            </Title>
            <Stack>
              <Checkbox
                label={
                  <Text size="sm" c="dark">
                    Same as organization
                  </Text>
                }
                onClick={() => setUrlIsOrganization(!urlIsOrganization)}
                checked={urlIsOrganization}
              />
              <TextInput
                maw={450}
                size="md"
                defaultValue="organization.com"
                description="Do not include “www.” unless required to access the site."
                label="Website"
                disabled={urlIsOrganization}
                withAsterisk
              />
              <TextInput
                maw={450}
                size="md"
                defaultValue="https://example.com/privacy-policy"
                label="Privacy policy"
                disabled={urlIsOrganization}
                withAsterisk
              />
              <TextInput
                maw={450}
                size="md"
                defaultValue="https://example.com/terms-of-service"
                label="Terms of service"
                disabled={urlIsOrganization}
                withAsterisk
              />
            </Stack>
          </Stack>
          <Flex maw={450} mt="lg" justify="flex-end" gap="xs">
            <Button size="md" variant="default">
              Discard Changes
            </Button>
            <Button size="md">Save</Button>
          </Flex>
        </Box>
      </Flex>
    </>
  )
}
